import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'CG',
  name: 'Camila G.',
  role: '📍 Buenos Aires | Docente de Química Secundaria',
  quote: 'Compré el MegaPack un domingo a la noche. El lunes tenía todo el año de Química organizado. Nunca pensé que un material iba a ser tan completo. Las rúbricas para trabajos prácticos son exactamente lo que necesitaba.'
}, {
  initials: 'MG',
  name: 'Martín G.',
  role: '📍 GBA | Docente de Química Secundaria',
  quote: 'Empecé con el Pack Avanzado y no me arrepiento. El sistema completo era tan claro que las actividades secuenciadas de nomenclatura me cambiaron la forma de planificar.'
}, {
  initials: 'LG',
  name: 'Laura G.',
  role: '📍 Córdoba | Profesora de Ciencias Naturales',
  quote: 'Lo que más valoro es que está organizado POR AÑO. No tengo que adivinar qué le corresponde a cada curso. Todo ya está pensado, ordenado y listo.'
}, {
  initials: 'AT',
  name: 'Alejandra T.',
  role: '📍 Santa Fe | Docente de Química',
  quote: 'Llegué a marzo con todo listo por primera vez en 8 años de docencia. Las guías de laboratorio de química low cost me salvaron. Mis colegas me preguntaron cómo lo había preparado todo tan bien.'
}, {
  initials: 'RS',
  name: 'Roberto S.',
  role: '📍 Mendoza | Docente Secundaria',
  quote: 'Las rúbricas integradas me cambiaron la corrección de informes. Por fin evalúo con criterios claros y objetivos. Mis alumnos saben exactamente qué se espera de ellos en el laboratorio.'
}];
export function FullTestimonials() {
  return <section className="py-12 md:py-16 px-4 bg-brand-dark" data-id="element-130">
      <div className="max-w-4xl mx-auto" data-id="element-131">
        <h2 className="text-3xl md:text-4xl font-black text-center text-white mb-8 md:mb-12" data-id="element-132">
          Docentes que ya recuperaron sus fines de semana{' '}
          <br className="hidden md:block" data-id="element-133" />
          <span className="text-brand-blue" data-id="element-134">que ya tienen su Sistema:</span>
        </h2>

        <div className="space-y-6 md:space-y-8" data-id="element-135">
          {testimonials.map((t, i) => <div key={i} className="bg-white/5 p-6 md:p-8 rounded-2xl shadow-md border border-white/10" data-id="element-136">
              <div className="flex flex-col md:flex-row gap-4 md:gap-6 items-start" data-id="element-137">
                <div className="flex-shrink-0 flex flex-col items-center" data-id="element-138">
                  <div className="w-16 h-16 bg-brand-blue text-white rounded-full flex items-center justify-center text-xl font-bold mb-3" data-id="element-139">
                    {t.initials}
                  </div>
                  <div className="flex text-yellow-400" data-id="element-140">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-141" />)}
                  </div>
                </div>
                <div data-id="element-142">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-143">
                    {t.name}
                  </h4>
                  <p className="text-sm text-gray-400 font-medium mb-4" data-id="element-144">
                    {t.role}
                  </p>
                  <p className="text-lg text-gray-300 leading-relaxed italic" data-id="element-145">
                    "{t.quote}"
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}